import React from "react";

export default function PlayIcon() {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50 0C22.3861 0 0 22.3857 0 50C0 77.6143 22.3861 100 50 100C77.6139 100 100 77.6143 100 50C100 22.3857 77.6139 0 50 0ZM67.2812 52.6504L42.2812 68.2754C41.7754 68.5912 41.2002 68.75 40.625 68.75C40.1039 68.75 39.582 68.6203 39.1098 68.3578C38.1164 67.807 37.5 66.7617 37.5 65.625V34.375C37.5 33.2383 38.1164 32.193 39.1098 31.6422C40.1031 31.0883 41.3178 31.1219 42.2812 31.7246L67.2812 47.3496C68.1945 47.9219 68.75 48.9229 68.75 50C68.75 51.0771 68.1945 52.0783 67.2812 52.6504Z"
        fill="white"
      />
    </svg>
  );
}
